import styled, { css } from 'styled-components';
import Box from '../../../../_shared/components/Box';
import { Make, Model, Year } from '../../../Vdp/Overview/VehicleInfo/Styles';

const wordWrap = css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledTitle = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  &:hover,
  &:active,
  &:focus,
  &:visited {
    color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  }
`;
export const StyledMakeModelYear = styled(StyledTitle)`
  font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  padding: 8px 0px 13px;
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 24px;
  inline-size: 150px;
  flex-grow: 1;
`;

export const StyledTitleInfo = styled(Box)`
  flex: 0 0 auto;
`;

export const StyledPendingYear = styled(Year)`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
`;

export const StyledPendingMake = styled(Make)`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
`;

export const StyledPendingModel = styled(Model)`
  font-size: ${({ theme }) => theme.FONT_SIZES.LARGE};
  ${wordWrap}
`;

export const StyledPendingMakeModel = styled.div`
  display: flex;
  ${wordWrap}
`;

export const StyledLaunchingToActive = styled.div`
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: 14px;
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
`;
